/**
 * TraceKit configuration types
 */

import { TraceKitPlugin } from './plugins';
import { getApiBaseUrl, getEnvironment } from '../utils/env';
import { ThemeConfig } from './theme';

export interface TraceKitConfig {
  api: {
    baseUrl: string;
    timeout: number;
    retries: number;
  };
  
  features: {
    rag: boolean;
    reports: boolean;
    entities: boolean;
    sources: boolean;
    jobs: boolean;
    webhooks: boolean;
    cache: boolean;
    admin: boolean;
  };
  
  branding: {
    appName: string;
    logo: string;
    logoUrl?: string; // URL or path to logo (replaces 'logo')
    logoAlt?: string; // Alt text for logo
    favicon: string;
    primaryColor: string;
    secondaryColor: string;
    companyName?: string;
    platformTitle?: string; // Title shown in sidebar (defaults to appName)
    platformSubtitle?: string; // Subtitle shown in sidebar
  };
  
  theme?: ThemeConfig;
  
  deployment: {
    environment: 'development' | 'staging' | 'production';
    domain: string;
    enableAnalytics: boolean;
  };
  
  plugins: TraceKitPlugin[];
  
  customization?: {
    defaultTenantId?: string;
    defaultProjectId?: string;
    hideTenantSelector?: boolean;
    customRoutes?: Array<{ path: string; component: React.ComponentType<any> }>;
    searchSampleQueries?: string[];
    entityTypes?: string[];
    featureFlags?: {
      // RFP Agent feature flags
      enableCalendarView?: boolean;              // Calendar view in opportunities dashboard
      enableCustomSections?: boolean;             // Custom sections tab in reports
      enableWordCountOptimizer?: boolean;        // Word count optimizer (counts always visible)
      enableQualityAssurance?: boolean;          // Quality assurance tab in reports
      enableReviewWorkflow?: boolean;             // Review workflow tab in reports
      enableAvailabilityCalendar?: boolean;       // Availability calendar tab in staff management
      enableQualificationsCerts?: boolean;        // Qualifications & certifications tab in staff management
      enableExecutiveDashboard?: boolean;         // Executive dashboard page
      enableWorkPlanExecution?: boolean;          // Work plan execution dashboard page
    };
  };
}

export const DEFAULT_CONFIG: TraceKitConfig = {
  api: {
    baseUrl: getApiBaseUrl(),
    timeout: 120000,
    retries: 3,
  },
  features: {
    rag: true,
    reports: true,
    entities: true,
    sources: true,
    jobs: true,
    webhooks: false,
    cache: false,
    admin: false,
  },
  branding: {
    appName: 'TraceKit',
    logo: '/logo.svg',
    logoUrl: '/logo.svg',
    logoAlt: 'TraceKit Logo',
    favicon: '/favicon.ico',
    primaryColor: '#3B82F6',
    secondaryColor: '#10B981',
    platformTitle: 'TraceKit',
    platformSubtitle: 'Evidence Platform',
  },
  theme: {
    defaultMode: 'dark',
    allowToggle: true,
  },
  deployment: {
    environment: getEnvironment(),
    domain: 'localhost:3000',
    enableAnalytics: false,
  },
  plugins: [],
};


